/* HILO · Process steps — phone stacked cards (styles: assets/hilo-steps-stack.css)
   On phones (≤767px) adds .hss-on to each [data-hh-steps][data-hss] list so
   its cards stick under the header, then, on scroll, sets --hss-d on every
   step: how far the cards after it have slid over it (0–3). The header's
   height is measured once the list comes into view, so the cards stop just
   below it. Skipped for reduced motion. Re-runs when the theme editor
   reloads the section, and switches off/on when the screen crosses 767px. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mq = window.matchMedia('(max-width: 767px)');
  var lists = [];
  function each(l, fn) { Array.prototype.forEach.call(l, fn); }
  function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }

  /* Bottom edge of whatever is pinned near the top of the screen: the
     stuck header, which can sit below a pinned announcement bar. */
  function headerBottom() {
    var b = 0;
    each(document.querySelectorAll('.shopify-section-group-header-group, #shopify-section-header, .header-sticky-wrapper, .site-header, .announcement-bar, header'), function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < 150 && r.top > -5 && r.bottom > b && r.bottom < 260) b = r.bottom;
    });
    return b;
  }

  function update(L) {
    var items = L.items;
    var ps = [0];
    for (var i = 1; i < items.length; i++) {
      var span = items[i - 1].offsetHeight + L.gap;
      ps.push(clamp(1 - (items[i].getBoundingClientRect().top - L.top) / span));
    }
    for (var k = 0; k < items.length; k++) {
      var d = 0;
      for (var j = k + 1; j < items.length; j++) d += ps[j];
      d = Math.min(d, 3);
      if (Math.abs(d - (items[k].hssD || 0)) > 0.002 || (d === 0 && items[k].hssD)) {
        items[k].hssD = d;
        items[k].style.setProperty('--hss-d', d.toFixed(3));
      }
    }
  }

  function setup(list) {
    if (list.hssReady) return;
    list.hssReady = true;
    var L = { list: list, items: [].slice.call(list.querySelectorAll('.hh-step')), top: 84, gap: 24, visible: false };
    L.measure = function () {
      var t = Math.round(headerBottom() + 16);
      if (t !== L.top) { L.top = t; list.style.setProperty('--hss-top', t + 'px'); }
      L.gap = parseFloat(getComputedStyle(list).rowGap) || 0;
    };
    L.mode = function () {
      var on = mq.matches;
      list.classList.toggle('hss-on', on);
      if (on) { L.measure(); update(L); return; }
      each(L.items, function (it) { it.hssD = 0; it.style.removeProperty('--hss-d'); });
    };
    lists.push(L);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          L.visible = e.isIntersecting;
          if (L.visible && mq.matches) { L.measure(); update(L); }
        });
      }).observe(list);
    } else {
      L.visible = true;
    }
    L.mode();
  }

  /* The header sticks (or hides) as the page scrolls, so its height is
     re-checked every 20 frames while the list is on screen. */
  var ticking = false, frame = 0;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (!mq.matches) return;
      frame++;
      lists = lists.filter(function (L) { return document.documentElement.contains(L.list); });
      lists.forEach(function (L) {
        if (!L.visible) return;
        if (frame % 20 === 0) L.measure();
        update(L);
      });
    });
  }
  function onChange() { lists.forEach(function (L) { L.mode(); }); }

  function init(scope) { each((scope || document).querySelectorAll('[data-hh-steps][data-hss]'), setup); }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { if (mq.matches) lists.forEach(function (L) { L.measure(); }); onScroll(); });
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
